<script lang="ts">
import omit from 'lodash.omit'

import type { AnyTemplate } from '~/types'

import type { Props as SvgHelperProps } from '../SvgHelper.vue'
</script>

<script lang="ts" setup>
const props = defineProps<SvgHelperProps & { template: AnyTemplate }>()
const svgHelperProps = computed(() => omit(props, 'template'))
const language = computed(() => isV2UserTemplate(props.template)
  ? props.template.template?.language
  : getTemplateField('language', props.template))
</script>

<template>
  <Flag
    v-bind="svgHelperProps"
    :language
  />
</template>
